export { default } from './CmsImg'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Utils/CmsImg/index.js